import { Box } from "@mui/material";
import ExportAlertsButton from "components/common/ExportAlertsButton";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';

function CustomToolbar({ onExportCSV, exporting, exportError }) {
  return (
    <GridToolbarContainer>
      <ExportAlertsButton onExportCSV={onExportCSV} exporting={exporting} exportError={exportError} />
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector
        slotProps={{ tooltip: { title: 'Change density' } }}
      />
      <GridToolbarExport
        slotProps={{
          tooltip: { title: 'Export data' },
          button: { variant: 'outlined' },
        }}
      />
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  );
}

export default CustomToolbar;
